import Aauthority from '@/components/Aauthority';
import AuploadFile from '@/components/Aupload/File';
import './index.css';

export default {
  name: 'Aactions',
  components: {
    Aauthority,
    AuploadFile,
  },
  props: {
    data: { type: Array, default: () => null },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
    size: { type: String, default: () => 'small' },
    access: { type: String || Array, default: () => '' },
    loading: { type: Boolean, default: () => false },
    disabled: { type: Boolean, default: () => false },
  },
  methods: {
    create() {
      const data = this.options || this.option || this.config || this.items || this.data || [];
      const { padding = '0 0 14px 0', margin } = this.$attrs;
      return (
        <div class="a-actions" style={{ padding, margin }}>
          {data && ((data.length > 0) && (data.map((a, b) => {
            const text = a.label || a.title || a.text || a.name || null;
            if (text) {
              const code = a.value || a.code || a.key || a.id || null;
              if (code) {
                return (<Aauthority access={this.access} code={code}> {this.format(a, b)}</Aauthority>);
              }
              return this.format(a, b);
            }
          })))}
          {this.$slots.default}
        </div>
      );
    },
    format({ type, ...a }, index) {
      if (a.render) return a.render(a, index);
      const text = a.label || a.title || a.text || a.name || null;
      const size = a.size || this.size || null;
      const disabled = this.loading || (a.disabled || this.disabled);
      const { selectedKeys = [], selectedRows = [] } = this.$store.state;
      const params = { keys: selectedKeys, rows: selectedRows };
      if (type) {
        if (type == 'upload') {
          return (<AuploadFile key={index} text={text} buttonSize={size} disabled={disabled} on-change={a.change ? e => a.change(e) : () => null} />);
        }
        if ((type == 'danger') || (type == 'remove') || (type == 'delete')) {
          return (
            <el-button
              plain
              key={index}
              type="danger"
              size={size}
              disabled={(selectedKeys.length === 0) || disabled}
              on-click={e => this.select(a, e)}
            >
              {text}
            </el-button>
          );
        }
      }
      return (
        <el-button
          plain
          key={index}
          type={type}
          size={size}
          disabled={disabled}
          style={{ color: a.color, background: a.background, ...a.style }}
          on-click={(e) => a.click(params, a, e)}
        >
          {text}
        </el-button>
      );
    },
    select(a, e) {
      e.preventDefault();
      const { selectedKeys = [], selectedRows = [] } = this.$store.state;
      const params = { keys: selectedKeys, rows: selectedRows };
      const keyword = selectedKeys.length > 1 ? (<span class="keyword">已选中的<b>{selectedKeys.length}</b>条</span>) : '此';
      const message = (<span class="a-actions-dialog-content">是否确定要删除{keyword}数据记录?</span>);
      const customClass = 'a-actions-dialog';
      const confirmButtonText = '确定';
      const cancelButtonText = '取消';
      this.$confirm(message, '操作提示', { customClass, confirmButtonText, cancelButtonText, type: 'warning' }).then(() => {
        a.click && a.click(params);
        a.select && a.select(params);
        a.choose && a.choose(params);
        a.handle && a.handle(params);
        a.remove && a.remove(params);
        a.delete && a.delete(params);
      }).catch(() => null);
    },
  },
  render() {
    return this.create();
  }
}